import React from "react"

import footerSubmit from "../assets/images/Icons/arrow.svg"

import "./SubscribeNewsletterForm.scss"

const SubscribeNewsletterForm = () => {
  const [formsState, setFormsState] = React.useState({
    email: "",
  })

  const [message, setMessage] = React.useState("")

  const encode = (data) => {
    return Object.keys(data)
      .map(
        (key) => encodeURIComponent(key) + "=" + encodeURIComponent(data[key])
      )
      .join("&")
  }

  const handleChange = (e) => {
    setFormsState({
      email: e.target.value,
    })
  }

  const handleSubmit = (e) => {
    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({ "form-name": "newsletter", ...formsState }),
    })
      .then(() => {
        setMessage("Success!")
        setFormsState({
          email: "",
        })
      })
      .catch((error) => setMessage(error))

    e.preventDefault()
  }
  return (
    <div className="subscribe-container">
      <form
        className="subscribe-newsletter-form"
        onSubmit={handleSubmit}
        name="newsletter"
        method="POST"
        data-netlify="true"
      >
        <input type="hidden" name="form-name" value="contact" />

        <input
          type="email"
          name="email"
          className="subscribe-newsletter-form__inp"
          placeholder="Newsletter Subscribe"
          onChange={handleChange}
          value={formsState.email}
          required
        />

        <button type="submit" className="subscribe-newsletter-form__submit">
          <img src={footerSubmit} />
        </button>
      </form>
      <p className="subscribe-container__message">{message}</p>
    </div>
  )
}

export default SubscribeNewsletterForm
